import React from "react";

import { GameProps } from "./types";
import { useGame } from "./hooks";

export const Game = (props: GameProps) => {
  const { getGameProps, getIdProps, getStatusProps, values } = useGame(props);
  return values.isVisible ? (
    <div {...getGameProps()}>
      <span {...getStatusProps()}>{values.status}</span>
      <span {...getIdProps()}>{props.game.id}</span>
    </div>
  ) : null;
};
